import { default as FullAppTemplateBase } from './CRT';
import { default as FullAppHeader } from './HeaderSction';
import { default as FullAppMain } from './MainSection';
import { default as FullAppFooter } from './FooterSection';
let CRTTemplateTemp = FullAppTemplateBase;
CRTTemplateTemp.Header = FullAppHeader;
CRTTemplateTemp.Main = FullAppMain;
CRTTemplateTemp.Footer = FullAppFooter;
const FullAppTemplate = CRTTemplateTemp;
export { FullAppTemplate };
//# sourceMappingURL=index.js.map